import styled from 'styled-components';
import { prop, palette } from 'styled-tools';

export const ImageItemContainer = styled.div`
  display: flex;
  width: 100%;
  height: 60px;
  margin: 8px 0px;
  align-items: center;
`;

interface ImageProps {
  background?: string;
  opacity?: number;
}

export const Image = styled.div<ImageProps>`
  border-radius: 8px;
  display: flex;
  min-width: 60px;
  min-height: 60px;
  background-size: cover;
  background-image: url('${prop('background')}');
  opacity: ${({opacity}) => opacity};
`;

export const FileTitle = styled.div`
  width: 45%;
  margin: 0px 10px;
  color: ${palette('gray_opacity_600')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FileState = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 55%;
`;

export const FileStateContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const DeleteButton = styled.button`
  width: 81px;
  height: 32px;
  cursor: pointer;
  outline: 0;
  line-height: normal;
  padding: 5px 11px;
  margin: 0px 17px;
  background-color: ${palette('gray_opacity_400')};
  color: ${palette('gray_opacity_50')};
  border: none;
  border-radius: 8px;
`;
